import _ from 'lodash'

export const convertArrayToObject = (questionArr) => {
  return _.cloneDeep(
    _.reduce(questionArr, function(hash, value) {
      var ID = value['surveyID'] + '_' + value['id'];
      hash[ID] = Object.assign({}, value);
      return hash;
    }, {})
  )
}

export const convertTagValueToObject = (value) => {
  var obj = {}
  obj[value] = value;
  return _.cloneDeep(obj)
}

export const isObject = (value) => {
  return value && typeof value === 'object' && value.constructor === Object;
}


// WEBPACK FOOTER //
// ./src/util/index.js